import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const PUBLIC_BASE_URL = process.env.REACT_APP_PUBLIC_BASE_URL;

export const api = axios.create({ baseURL: `${BACKEND_URL}/api`, withCredentials: true });

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const orig = error.config || {};
    if (error.response?.status === 401 && !orig._retry && !String(orig.url).includes("/auth/")) {
      orig._retry = true;
      try {
        await api.post("/auth/refresh");
        return api(orig);
      } catch (e) {
        /* fallthrough */
      }
    }
    return Promise.reject(error);
  }
);

export const fileUrl = (u) => (!u ? "" : u.startsWith("/api/") ? `${BACKEND_URL}${u}` : u);
export const publicCardUrl = (slug) => `${PUBLIC_BASE_URL}/c/${slug}`;
export const qrTargetUrl = (slug) => `${publicCardUrl(slug)}?s=qr`;
export const vcardUrl = (slug, src) => `${BACKEND_URL}/api/public/cards/${slug}/vcard${src === "qr" ? "?src=qr" : ""}`;

export function formatErr(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Si è verificato un errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export async function uploadImage(file) {
  return (await uploadFile(file)).url;
}

export async function uploadFile(file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/uploads", fd);
  return data;
}

export async function copyText(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (e) {
    const ta = document.createElement("textarea");
    ta.value = text;
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    return ok;
  }
}
